module.exports = __webpack_public_path__ + "img/full-slide-1.f64eaa88.jpg";